"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _slice = require("@lce/slice");

var Styled = _interopRequireWildcard(require("./ErrorMessage.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ErrorMessage = function ErrorMessage(_a) {
  var headline = _a.headline,
      messagePrefix = _a.messagePrefix,
      messageSuffix = _a.messageSuffix,
      phone = _a.phone;
  return _react["default"].createElement(Styled.Flex, null, _react["default"].createElement(Styled.Box, null, _react["default"].createElement(Styled.Graphic, {
    symbol: "halfEatenPizza"
  }), _react["default"].createElement(_slice.Headline, null, headline), _react["default"].createElement(_slice.Text, null, messagePrefix, _react["default"].createElement(Styled.Anchor, {
    color: "orange",
    href: "tel:" + phone
  }, phone), messageSuffix)));
};

var _default = ErrorMessage;
exports["default"] = _default;